<section class="progress-section mt-24">
  <div class="progress-container">
    <div
      class="progress-header d-flex align-items-center justify-content-between"
    >
      <h2 class="progress-title fts-20 font-bold-dali m-0">
        Tu progreso en el programa (para el {{ currentYear + 1 }})
      </h2>
    </div>

    <div class="progress-content mt-24">
      <section class="show-desktop-tablet">
        <div class="progress-bar-container mb-24">
          <mat-progress-bar
            class="custom-progress-bar"
            [mode]="'determinate'"
            [value]="mockProgressData.animatedProgress"
            [color]="'primary'"
          >
          </mat-progress-bar>
        </div>

        <div class="progress-levels d-flex justify-content-between mb-32">
          <div class="level-item text-start d-flex">
            <div class="ta-s">
              <img
                src="/assets/image/partners-ali/icon-badge-bronce.svg"
                alt="Bronce"
                class="level-icon"
              />
              <p
                class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
              >
                Aliado Bronce
              </p>
              <p
                class="level-amount fts-12 font-regular color-neutral-dark m-0"
              >
                <ngx-skeleton-loader
                  [theme]="{
                    width: '60px',
                    'border-radius': '5',
                    height: '8px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"
                ></ngx-skeleton-loader>
              </p>
            </div>
          </div>

          <div class="level-item ta-c">
            <img
              src="/assets/image/partners-ali/icon-badge-plata.svg"
              alt="Plata"
              class="level-icon"
            />
            <p
              class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
            >
              Aliado Plata
            </p>
            <p
              class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
            >
              <ngx-skeleton-loader
                [theme]="{
                  width: '60px',
                  'border-radius': '5',
                  height: '8px',
                  'margin-bottom': '0px',
                  'margin-top': '0px'
                }"
              ></ngx-skeleton-loader>
            </p>
          </div>

          <div class="level-item ta-c position-relative">
            <img
              src="/assets/image/partners-ali/icon-badge-oro.svg"
              alt="Oro"
              class="level-icon"
            />
            <p
              class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
            >
              Aliado Oro
            </p>
            <p
              class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
            >
              <ngx-skeleton-loader
                [theme]="{
                  width: '60px',
                  'border-radius': '5',
                  height: '8px',
                  'margin-bottom': '0px',
                  'margin-top': '0px'
                }"
              ></ngx-skeleton-loader>
            </p>
          </div>

          <div class="level-item d-flex justify-content-end">
            <div class="ta-r vw-100">
              <img
                src="/assets/image/partners-ali/icon-badge-diamond.svg"
                alt="Diamante"
                class="level-icon"
              />
              <p
                class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
              >
                Aliado Diamante
              </p>
              <p
                class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
              >
                <ngx-skeleton-loader
                  [theme]="{
                    width: '60px',
                    'border-radius': '5',
                    height: '8px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"
                ></ngx-skeleton-loader>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="show-mobile">
        <p-carousel
          #carouselGeneralALI
          [value]="cards"
          [numVisible]="1"
          [numScroll]="1"
          [circular]="false"
          [showNavigators]="false"
          [showIndicators]="false"
          styleClass="custom-carousel-ALI"
        >
          <!-- Plantilla de cada ítem del carrusel -->
          <ng-template pTemplate="item" let-card>
            <div class="dinamic-card">
              <ng-container [ngSwitch]="card.id">
                <div class="progress-bar-container mb-24">
                  <mat-progress-bar
                    class="custom-progress-bar"
                    mode="determinate"
                    [value]="mockProgressData.animatedProgress"
                    color="primary"
                  ></mat-progress-bar>
                  <!-- Card 1 -->
                  <div
                    *ngSwitchCase="1"
                    class="progress-levels-mobile d-flex justify-content-between mt-16"
                  >
                    <div class="level-item text-start d-flex">
                      <div class="ta-s">
                        <img
                          src="/assets/image/partners-ali/icon-badge-bronce.svg"
                          alt="Bronce"
                          class="level-icon"
                        />
                        <p
                          class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                        >
                          Aliado Bronce
                        </p>
                        <p
                          class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                        >
                          <ngx-skeleton-loader
                            [theme]="{
                              width: '60px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"
                          ></ngx-skeleton-loader>
                        </p>
                      </div>
                    </div>
                    <div class="level-item ta-c">
                      <img
                        src="/assets/image/partners-ali/icon-badge-plata.svg"
                        alt="Plata"
                        class="level-icon"
                      />
                      <p
                        class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                      >
                        Aliado Plata
                      </p>
                      <p
                        class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                      >
                        <ngx-skeleton-loader
                          [theme]="{
                            width: '60px',
                            'border-radius': '5',
                            height: '8px',
                            'margin-bottom': '0px',
                            'margin-top': '0px'
                          }"
                        ></ngx-skeleton-loader>
                      </p>
                    </div>
                  </div>
                  <!-- Card 2 -->
                  <div
                    *ngSwitchCase="2"
                    class="progress-levels-mobile d-flex justify-content-between mt-16"
                  >
                    <div class="level-item text-start d-flex">
                      <div class="ta-c">
                        <img
                          src="/assets/image/partners-ali/icon-badge-plata.svg"
                          alt="Plata"
                          class="level-icon"
                        />
                        <p
                          class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                        >
                          Aliado Plata
                        </p>
                        <p
                          class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                        >
                          <ngx-skeleton-loader
                            [theme]="{
                              width: '60px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"
                          ></ngx-skeleton-loader>
                        </p>
                      </div>
                    </div>
                    <div class="level-item ta-c position-relative">
                      <img
                        src="/assets/image/partners-ali/icon-badge-oro.svg"
                        alt="Oro"
                        class="level-icon"
                      />
                      <p
                        class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                      >
                        Aliado Oro
                      </p>
                      <p
                        class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                      >
                        <ngx-skeleton-loader
                          [theme]="{
                            width: '60px',
                            'border-radius': '5',
                            height: '8px',
                            'margin-bottom': '0px',
                            'margin-top': '0px'
                          }"
                        ></ngx-skeleton-loader>
                      </p>
                    </div>
                  </div>
                  <!-- Card 3 -->
                  <div
                    *ngSwitchCase="3"
                    class="progress-levels-mobile d-flex justify-content-between mt-16"
                  >
                    <div class="level-item text-start d-flex">
                      <div class="ta-c">
                        <img
                          src="/assets/image/partners-ali/icon-badge-oro.svg"
                          alt="Oro"
                          class="level-icon"
                        />
                        <p
                          class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                        >
                          Aliado Oro
                        </p>
                        <p
                          class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                        >
                          <ngx-skeleton-loader
                            [theme]="{
                              width: '60px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"
                          ></ngx-skeleton-loader>
                        </p>
                      </div>
                    </div>
                    <div class="level-item d-flex justify-content-end">
                      <div class="ta-r vw-100">
                        <img
                          src="/assets/image/partners-ali/icon-badge-diamond.svg"
                          alt="Diamante"
                          class="level-icon"
                        />
                        <p
                          class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                        >
                          Aliado Diamante
                        </p>
                        <p
                          class="level-name fts-14 font-bold-dali color-neutral-darkest m-0 mt-8"
                        >
                          <ngx-skeleton-loader
                            [theme]="{
                              width: '60px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"
                          ></ngx-skeleton-loader>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
          <!-- Plantilla para el pie del carrusel (navegación) -->
          <ng-template pTemplate="footer">
            <div class="custom-carousel-nav">
              <button
                type="button"
                class="custom-nav-button"
                [class.disabled]="true"
              >
                <img
                  src="assets/image/essentials/arrow-left.svg"
                  alt="previous"
                />
              </button>

              <div class="custom-indicators d-sm-flex">
                <button
                  *ngFor="let _ of getTotalPages(); let i = index"
                  type="button"
                  class="custom-indicator"
                ></button>
              </div>

              <button
                type="button"
                class="custom-nav-button"
                [class.disabled]="true"
              >
                <img src="assets/image/essentials/arrow-right.svg" alt="next" />
              </button>
            </div>
          </ng-template>
        </p-carousel>
      </section>

      <!-- esto se reutiliza apra ambas pantallas -->
      <div class="achievements-section">
        <div class="achievements-grid d-flex justify-content-between">
          <div class="vw-100 ta-s">
            <div>
              <ngx-skeleton-loader
                [theme]="{
                  width: '228px',
                  'border-radius': '5',
                  height: '8px',
                  'margin-bottom': '0px',
                  'margin-top': '0px'
                }"
              ></ngx-skeleton-loader>
            </div>
            <ngx-skeleton-loader
              [theme]="{
                width: '160px',
                'border-radius': '5',
                height: '8px',
                'margin-bottom': '0px',
                'margin-top': '0px'
              }"
            ></ngx-skeleton-loader>
          </div>

          <div class="achievement-card-middle">
            <div class="achievement-content-horizontal">
              <div class="achievement-left">
                <div
                  class="achievement-content-left d-flex justify-content-between align-items-center"
                >
                  <div class="achievement-text-content">
                    <h4
                      class="achievement-title fts-14 font-bold-dali color-neutral-darkest m-0 mb-8"
                    >
                      <ngx-skeleton-loader
                        [theme]="{
                          width: '196px',
                          'border-radius': '5',
                          height: '8px',
                          'margin-bottom': '0px',
                          'margin-top': '0px'
                        }"
                      ></ngx-skeleton-loader>
                    </h4>
                    <div
                      class="achievement-details d-flex justify-content-between"
                    >
                      <div class="achievement-detail-column">
                        <p
                          class="achievement-text fts-14 font-regular color-neutral-dark m-0 mb-4"
                        >
                          <ngx-skeleton-loader
                            [theme]="{
                              width: '60px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"
                          ></ngx-skeleton-loader>
                        </p>
                        <p
                          class="achievement-value fts-14 font-bold-dali color-neutral-dark m-0"
                        >
                          <ngx-skeleton-loader
                            [theme]="{
                              width: '86px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"
                          ></ngx-skeleton-loader>
                        </p>
                      </div>
                      <div class="achievement-detail-column">
                        <p
                          class="achievement-text fts-14 font-regular color-neutral-dark m-0 mb-4"
                        >
                          <ngx-skeleton-loader
                            [theme]="{
                              width: '46px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"
                          ></ngx-skeleton-loader>
                        </p>
                        <p
                          class="achievement-value fts-14 font-bold-dali color-neutral-dark m-0"
                        >
                          <ngx-skeleton-loader
                            [theme]="{
                              width: '30px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"
                          ></ngx-skeleton-loader>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="achievement-medal-right">
                    <ngx-skeleton-loader
                      [theme]="{
                        width: '40px',
                        'border-radius': '5',
                        height: '53px',
                        'margin-bottom': '0px',
                        'margin-top': '0px'
                      }"
                    ></ngx-skeleton-loader>
                  </div>
                </div>
              </div>
              <div class="dl-divider mt-16 mb-16"></div>
              <div class="achievement-right">
                <div class="achievement-header mb-8">
                  <ngx-skeleton-loader
                    [theme]="{
                      width: '158px',
                      'border-radius': '5',
                      height: '8px',
                      'margin-bottom': '0px',
                      'margin-top': '0px'
                    }"
                  ></ngx-skeleton-loader>
                  <ngx-skeleton-loader
                    [theme]="{
                      width: '30px',
                      'border-radius': '5',
                      height: '8px',
                      'margin-bottom': '0px',
                      'margin-top': '0px'
                    }"
                  ></ngx-skeleton-loader>
                </div>
                <div class="achievement-details">
                  <p
                    class="achievement-text fts-14 font-regular color-neutral-dark m-0"
                  >
                    <ngx-skeleton-loader
                      [theme]="{
                        width: '100px',
                        'border-radius': '5',
                        height: '8px',
                        'margin-bottom': '0px',
                        'margin-top': '0px'
                      }"
                    ></ngx-skeleton-loader>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="achievement-card-large">
            <div
              class="achievement-content-large d-flex justify-content-between align-items-center"
            >
              <div class="achievement-text-content-large">
                <ngx-skeleton-loader
                  [theme]="{
                    width: '254px',
                    'border-radius': '5',
                    height: '8px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{
                    width: '254px',
                    'border-radius': '5',
                    height: '8px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{
                    width: '160px',
                    'border-radius': '5',
                    height: '8px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"
                ></ngx-skeleton-loader>
              </div>
              <div class="achievement-focus-right">
                <ngx-skeleton-loader
                  [theme]="{
                    width: '40px',
                    'border-radius': '5',
                    height: '56px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"
                ></ngx-skeleton-loader>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="progress-footer mt-24">
        <p class="footer-text fts-12 font-regular color-title-custom m-0 ta-s">
          La reevaluación se realizará en enero del {{ currentYear + 1 }}, se
          tiene en consideración la venta acumulada de enero a diciembre de
          {{ currentYear }}. La venta está calculada con el Importe Real
          Facturado. Categorías no consideradas: panetones, chocolates de taza y
          socios comerciales.
        </p>
      </div>
    </div>
  </div>
</section>
